import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { Icon } from './Icon';
import './CircleArrowButton.css';

/**
 * Figma Circle Arrow — circular icon button (tone light|dark).
 */
export function CircleArrowButton({
  tone = 'light',
  direction = 'forward',
  'aria-label': ariaLabel = 'Continue',
  className = '',
  ...props
}) {
  const icon = direction === 'back' ? 'arrowBack' : 'arrowForward';
  return (
    <IconButton
      className={[
        'onyx-circle-arrow',
        `onyx-circle-arrow--${tone}`,
        className,
      ].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
      data-testid="onyx-circle-arrow"
      data-tone={tone}
      {...props}
    >
      <Icon name={icon} size="md" />
    </IconButton>
  );
}

CircleArrowButton.propTypes = {
  tone: PropTypes.oneOf(['light', 'dark']),
  direction: PropTypes.oneOf(['forward', 'back']),
  'aria-label': PropTypes.string,
  className: PropTypes.string,
};

export default CircleArrowButton;
